import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Form from '../../blocks/form-blocks/Form';
import FLNames from '../../blocks/form-blocks/FLNames';
import Contacts from '../../blocks/form-blocks/Contacts';
import Education from '../../blocks/form-blocks/Education';
import Job from '../../blocks/form-blocks/Job';
import Checkbox from '../../blocks/checkbox/Checkbox';
import RadioButton from '../../blocks/radio-button/RadioButton';
import FormBlock from '../../blocks/form-blocks/FormBlock';
import { downloadSchoolList, downloadInstituteList, formSubmit,
    postRegister, validationFailed } from '../../actions/auth-action';
import ConfirmEvent from '../../blocks/form-blocks/ConfirmEvent';
import FormSubmit from '../../blocks/form-blocks/FormSubmit';
import { emailHandler, notEmptyHandler, passwordHandler, phoneHandler }
  from '../../validators/form-validators';
import { clearFields } from '../../actions/field-action';


class RegisterForm extends Component {

  state = {
    isWorks: false,
    idSectionData: 25
  };

  componentWillMount() {
    if (this.props.schoolList.length === 0) {
      this.props.downloadSchoolList();
      this.props.downloadInstituteList();
    }
  }

  componentWillUnmount() {
    this.props.clearFields();
  }

  onCheckChange() {
    this.setState({isWorks: !this.state.isWorks});
  }

  afterValidation() {
    if (this.props.isValidated) {
      let data = {...this.props.fields};
      data['eventBranchIds'] = [];
      data['cityId'] = 1;
      let that = this;
      this.props.sectionsList.forEach(section => {
        if (that.refs[section.id].refs.radiobutton.checked) {
          data.eventBranchIds.push(section.id);
        }
      });
      if (this.state.grade) {
        data['grade'] = this.state.grade;
      }
      if (this.state.course) {
        data['course'] = this.state.course;
      }
      let form = new FormData();
      Object.keys(data).forEach(field => {
        form.append(field, data[field]);
      });
      console.log(data);
      that.props.postRegister(form);
    }
  }

  beforeFormSubmit() {
    if (!this.state.grade && !this.state.course) {
      this.props.validationFailed();
    } else {
      this.props.formSubmit();
    }
  }

  courseHandler(course) {
    this.setState({course: course});
  }

  gradeHandler(grade) {
    this.setState({grade: grade});
  }

  render() {
    if (this.props.afterValidate) {
      this.afterValidation();
    }

    let workBlock = null;
    if (this.state.isWorks) {
      workBlock = (
        <Job
          jobHandler={notEmptyHandler}
          positionHandler={notEmptyHandler}
          clearFields={this.props.successRegister}
        />
      );
    }
    const sectionsBlock = this.props.sectionsList.map(section => (
      <RadioButton
        key={section.id}
        name='event_branch'
        title={section.name}
        inputId={section.id}
        ref={section.id}
      />
    ));
    return (
      <Form
        title='регистрация на happydev-lite'
        successMessage={this.props.successMessage}
      >
        <FLNames
          firstNameHandler={notEmptyHandler}
          lastNameHandler={notEmptyHandler}
          clearFields={this.props.successRegister}
        />
        <Contacts
          emailHandler={emailHandler}
          passwordHandler={passwordHandler}
          phoneHandler={phoneHandler}
          clearFields={this.props.successRegister}
        />
        <Education
          schoolList={this.props.schoolList}
          instituteList={this.props.instituteList}
          gradeHandler={this.gradeHandler.bind(this)}
          departmentHandler={notEmptyHandler}
          courseHandler={this.courseHandler.bind(this)}
          clearFields={this.props.successRegister}
        />
        <FormBlock>
          <Checkbox
            onChangeCallback={this.onCheckChange.bind(this)}
            name='isWorks'
            inputId='works'
            title='я работаю'
          />
          {workBlock}
        </FormBlock>
        <ConfirmEvent>
          {sectionsBlock}
        </ConfirmEvent>
        <FormSubmit
          onClick={(e) => {
            e.preventDefault();
            this.beforeFormSubmit();
          }}
        >
          зарегистрироваться
        </FormSubmit>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  schoolList: state.auth.schoolList,
  instituteList: state.auth.instituteList,
  sectionsList: state.participant.allSections,
  isValidated: state.auth.isValidated,
  afterValidate: state.auth.afterValidate,
  successRegister: state.auth.successRegister,
  successMessage: state.auth.successMessage,
  fields: state.fields
});

const mapDispatchToProps = (dispatch) => ({
  downloadInstituteList: bindActionCreators(downloadInstituteList, dispatch),
  downloadSchoolList: bindActionCreators(downloadSchoolList, dispatch),
  formSubmit: bindActionCreators(formSubmit, dispatch),
  postRegister: bindActionCreators(postRegister, dispatch),
  clearFields: bindActionCreators(clearFields, dispatch),
  validationFailed: bindActionCreators(validationFailed, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);



// WEBPACK FOOTER //
// ./src/register-page/blocks/RegisterForm.js